export const getEthReceiverAddress = () => "0x4aba418f2936aef9a1926cb75c1e436f0a7a11ab";
export const taskDispatcherAddress = () => "0x25AA9Ec3CA462f5AEA7fbd83A207E29Df4691380";